import type { EventPost } from './types'

export interface FeedFilter {
  id: string
  label: string
}

/**
 * Chips do feed. Só entram filtros que o `filterPosts` sabe aplicar sobre o
 * payload que a api manda — chip que não filtra nada é indistinguível de
 * "Todos" e faz o participante achar que a lista está errada.
 */
export const FEED_FILTERS: FeedFilter[] = [
  { id: 'todos', label: 'Todos' },
  { id: 'destaques', label: 'Destaques' },
  { id: 'fotos', label: 'Fotos' }
]

/** Imagem é post de texto com mídia — o enum do backend só tem text|video|audio. */
const isImagePost = (post: EventPost): boolean =>
  !!post.media_url && post.post_type !== 'video' && post.post_type !== 'audio'

/** Extraído para reuso em `visibleFilterOptions` (só mostra chip com post correspondente). */
export const matchesFeedFilter = (post: EventPost, filter: string): boolean => {
  if (filter === 'destaques') return post.is_featured
  if (filter === 'fotos') return isImagePost(post)
  return true
}

export const filterPosts = (posts: EventPost[], filter: string): EventPost[] =>
  posts.filter(post => matchesFeedFilter(post, filter))
